import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // 1. Import Firestore

const firebaseConfig = {
  apiKey: "AIzaSyArlU-RzfuJqP15oraQix-JhI4mQ3aocg0",
  authDomain: "ooloz-74908.firebaseapp.com",
  projectId: "ooloz-74908",
  storageBucket: "ooloz-74908.firebasestorage.app",
  messagingSenderId: "774095297878",
  appId: "1:774095297878:web:e2db4535f6c7088ea9caf7"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app); // 2. Export Firestore instance